import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import SideBar from "./SideBar";
import Topbar from "./Topbar";

const Layout = () => {
  const [sideBarShow, setSideBarShow] = useState(false);
  return (
    <div className="">
      <Topbar setSideBarShow={setSideBarShow} sideBarShow={sideBarShow} />
      <div className="dashboard">
        <SideBar setSideBarShow={setSideBarShow} sideBarShow={sideBarShow} />
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;
